import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/** Public holiday from GET /api/v1/calendar/public-holidays */
export interface PublicHolidayDto {
  /** ISO date yyyy-MM-dd */
  date: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class SchoolCalendarService {

  private readonly base = `${environment.apiUrl}/api/v1/calendar`;

  constructor(private http: HttpClient) { }

  getPublicHolidays(year: number): Observable<PublicHolidayDto[]> {
    const params = new HttpParams().set('year', String(year));
    return this.http.get<PublicHolidayDto[]>(`${this.base}/public-holidays`, { params }).pipe(
      catchError(() => of([]))
    );
  }
}
